export const EMAIL_PATTERN = new RegExp(
    "(?!(^[.-].*|[^@]*[.-]@|.*\\.{2,}.*)|^.{254}.)([a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~.-]+@)(?!-.*|.*-\\.)([a-zA-Z0-9-]{1,63}\\.)+[a-zA-Z]{2,15}",
);

export const PASSWORD_CYRILLIC_REGEXP = new RegExp('[а-я]', 'gi');
